
export const Environment = {
  
  LIMITE_DE_LINHAS: 7,

  LIMITE_DE_LINHAS1: 8,

  LIMITE_DE_LINHASSMALL: 10,

  LIMITE_DE_CADASTRO: 8,
 
  INPUT_DE_BUSCA: 'Pesquisar...',
 
  LISTAGEM_VAZIA: 'Nenhum registro encontrado.',
 
  URL_BASE: window.env.REACT_APP_URL_BASE,

   
  URL_BASEFINANCEIRA: window.env.REACT_APP_URL_BASEFINANCEIRA,

  URL_BASEESTOQUE: window.env.REACT_APP_URL_BASEESTOQUE,

  URL_BASECADASTRO: window.env.REACT_APP_URL_BASECADASTRO,

  URL_BASELOGIN: window.env.REACT_APP_URL_BASELOGIN,

  URL_BASEFISCAL: window.env.REACT_APP_URL_BASEFISCAL,

  URL_IMGPATRIMONIO: window.env.REACT_APP_URL_IMGPATRIMONIO,

  URL_IMGUSUARIOS: window.env.REACT_APP_URL_IMGUSUARIO,

  URL_IMGCULTIVOS: window.env.REACT_APP_URL_IMGCULTIVOS,

  URL_PDFNFE: window.env.REACT_APP_URL_PDFNFE,

  URL_IMGPRODUTOS: window.env.REACT_APP_URL_IMGPRODUTOS,

  URL_IMGLOG: window.env.REACT_APP_URL_IMGLOG,

  URL_IDPARCEIRO: window.env.REACT_APP_IDPARCEIRO,

  URL_IDCONTA: window.env.REACT_APP_IDCONTA,

  URL_IDPLANODECONTAS: window.env.REACT_APP_IDPLANODECONTAS,
  
  URL_IDOPERACOES: window.env.REACT_APP_IDOPERACAO,

  URL_IDOPERACOESENTRADA: window.env.REACT_APP_IDOPERACAOENTRADA,
  
  URL_IDAJUSTEDEESTOQUEVENDA: window.env.REACT_APP_IDAJUSTEDEESTOQUEVENDA,

  URL_IDENTRADA: window.env.REACT_APP_IDENTRADA,

  URL_IDVENDA: window.env.REACT_APP_IDVENDA,

  URL_IDPLANODECONTASAJUSTEESTOQUE: window.env.REACT_APP_IDPLANODECONTASAJUSTEESTOQUE,
  
  URL_IDVENDAPRAZO: window.env.REACT_APP_IDVENDAPRAZO,
  URL_IDPIX: window.env.REACT_APP_IDPIX,
  URL_IDORCAMENTO: window.env.REACT_APP_IDORCAMENTO,
  URL_IDCARTAO: window.env.REACT_APP_IDCARTAO,

  COR_RELATORIOS: '#40481E',

  COR_RELATORIOS_TEXTO: '#000000'

};



